import { Inbox } from "lucide-react";

export const EmptyState = ({ message = "No data available" }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <Inbox className="h-12 w-12 text-gray-400" />
      <p className="text-sm text-gray-500">{message}</p>
    </div>
  );
};
